module.exports = __webpack_public_path__ + "static/media/user-small.43328538.png";